module.exports = __webpack_public_path__ + "img/mockup.7f3868c0.png";